// extracted by mini-css-extract-plugin
export default {"emptyDescription":"EmptyContainer_emptyDescription__R6jXq"};